import { IRootState } from "../reducers/root";
import { IStrings } from "../../constants/languageStrings/IStrings";

export function selectStrings(state: IRootState): IStrings {
    return state.localization.strings;
}
